import React from 'react'

const Manual_enviar_emails_dashboard_clau = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          ¿Cómo enviar emails a los usuarios dentro del Dashboard de Clau.io?
        </h2>
        <iframe
          src="https://scribehow.com/embed/Como_enviar_emails_a_los_usuarios_dentro_del_Dashboard_de_Clauio__t_qYeMt-T0OAGU7UCpEvpw?as=scrollable"
          className="scribe-iframe-general-82"
          width="100%"
          height="5600"
          allow="fullscreen"
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_enviar_emails_dashboard_clau
